// extracted by mini-css-extract-plugin
export default {"list":"_9D7d20qF"};